import React, {useState, useEffect} from 'react';
import AdminMenu from '../../components/Layouts/AdminMenu';
import Layout from '../../components/Layouts/Layout';
import  toast  from 'react-hot-toast';
import axios from 'axios';
import CategoryForm from '../../components/Form/CategoryForm';
import Modal from 'antd/es/modal/Modal';

const CreateCategory = () => {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [updatedName, setUpdatedName] = useState("");

  // handle Form
  const handleSubmit = async(e) => {
    e.preventDefault()
    try{
      const {data} = await axios.post(`/api/v1/category/create-category`, {name});
      if(data?.success){
        toast.success(`${name} is created`)
        getAllCategory();
      }else{
        toast.error(data.message);
      }

    }catch(error){
      // console.log(error);
      toast.error("Something went wrong in input form");
    }
  };

  // get all category
  const getAllCategory = async() => {
    try{
      const {data} = await axios.get(`/api/v1/category/all-category`);
      if(data.success){
        setCategories(data.category);
      }
    }catch(error){
      // console.log(error);
      toast.error("Something went wrongin getting category");
    }
  };
  
  //update category
  const handleUpdate = async(e) => {
    e.preventDefault();
    try{
      const {data} = await axios.put(`/api/v1/category/update-category/${selected._id}`,
      {name: updatedName});
      if(data.success){
        toast.success(`${updatedName} is updated`);
        setSelected(null);
        setUpdatedName("");
        setVisible(false);
        getAllCategory();
      }else{
        toast.error(data.message);
      }
    }catch(error){
      // console.log(error);
      toast.error("Something went wrong");
    }
  };

  //delete category
  const handleDelete = async(pid) => {
    
    try{
      const {data} = await axios.delete(`/api/v1/category/delete-category/${pid}`)
    
      if(data.success){
        toast.success(`category is deleted`);
        getAllCategory();
      }else{
        toast.error(data.message);
      }
    }catch(error){
      // console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <Layout title={"Dashboard- create product"}>
        <div className='container-fluid m-3 p-3'></div>
        <div className='row'>
            <div className='col-md-3'>
                <AdminMenu />
            </div>
            <div className='col-md-9'>
                <h1>Manage Category</h1>
                <div className='p-3 w-50'>
                  <CategoryForm 
                    handleSubmit={handleSubmit}
                    value={name}
                    setValue={setName}
                  />
                </div>
                <div className='w-75'>
                  <table className="table">
                      <thead>
                        <tr>
                          
                          <th scope="col">Name</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                          {
                            categories?.map((c) => (
                              <>
                                <tr>
                                  <td key={c._id}>{c.name}</td>
                                  <td>
                                    <button 
                                      className='btn btn-primary ms-2'
                                      onClick={() => {
                                        setVisible(true);
                                        setUpdatedName(c.name);
                                        setSelected(c);
                                      }}
                                    >
                                      Edit
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      className='btn btn-danger'
                                      onClick= {() => {handleDelete(c._id)}}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          }
                        
                      </tbody>
                    </table>
                </div>
                <Modal 
                  onCancel={() => setVisible(false)}
                  footer={null}
                  open={visible}
                >
                  <CategoryForm 
                    value={updatedName}
                    setValue={setUpdatedName}
                    handleSubmit={handleUpdate}
                  />
                  </Modal>
                
            </div>
        </div>
    </Layout>
  )
}

export default CreateCategory